/**
 * @generated SignedSource<<beb4d4d380082cadcf4980ac348d6e20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatePersonalizedNotificationTemplateInput = {
  clientMutationId?: string | null;
  key: string;
};
export type createPersonalizedNotificationTemplateButton_CreateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePersonalizedNotificationTemplateInput;
};
export type createPersonalizedNotificationTemplateButton_CreateMutation$data = {
  readonly Admin: {
    readonly Notification: {
      readonly createPersonalizedNotificationTemplate: {
        readonly edge: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment">;
          };
        };
      } | null;
    };
  };
};
export type createPersonalizedNotificationTemplateButton_CreateMutation = {
  response: createPersonalizedNotificationTemplateButton_CreateMutation$data;
  variables: createPersonalizedNotificationTemplateButton_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "NotificationTemplate",
    "kind": "LinkedField",
    "name": "template",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createPersonalizedNotificationTemplateButton_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreatePersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "createPersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedNotificationTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedNotificationTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment",
                            "selections": (v3/*: any*/),
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "createPersonalizedNotificationTemplateButton_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreatePersonalizedNotificationTemplatePayload",
                "kind": "LinkedField",
                "name": "createPersonalizedNotificationTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedNotificationTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edge",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedNotificationTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "edge",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86a7ce7a87fe90cadd9419991c62024b",
    "id": null,
    "metadata": {},
    "name": "createPersonalizedNotificationTemplateButton_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation createPersonalizedNotificationTemplateButton_CreateMutation(\n  $input: CreatePersonalizedNotificationTemplateInput!\n) {\n  Admin {\n    Notification {\n      createPersonalizedNotificationTemplate(input: $input) {\n        edge {\n          node {\n            ...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment on PersonalizedNotificationTemplate {\n  id\n  template {\n    key\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a1e74a31f8fc481c33f83143c123bb6";

export default node;
